/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
const InView = require('inview');
const debounce = require('../helpers/debounce');
/**
 * Inview component.
 * All DOM elements with class `.js-inview` will listen for inview and receive `is-active`
 * All DOM elements with class `js-inview-image` will have the HTML prepared for scripting,
 *   listen for a custom inview and have the width adjusted whenever they're inview
 *
 * Usage:
 * Call Inview.init() to initialize all $inviews and $inviewimages.
 *
 * Methods:
 *
 * init(): attaches eventlisteners to all $inviews and $inviewimages
 */

const $inviews = document.querySelectorAll('.js-inview');
const $inviewimages = document.querySelectorAll('.js-inview-image');
const inviewimagescbs = [];

const settings = {
	inview: {
		top: 0.35,
		bottom: 0.48,
	},
	inviewimage: {
		top: 0.75,
		bottom: 0,
		speed: 2
	}
};

const init = () => {
	if ($inviews.length > 0) {
		$inviews.forEach($el => {
			const elHeight = $el.clientHeight;
			InView($el, (isInView, data) => {
				// Adjust since it isn't correct
				let { elementOffsetTopInViewHeight } = data;
				elementOffsetTopInViewHeight += elHeight;
				const offsetTop = data.inViewHeight * settings.inview.top;
				const offsetBottom = data.inViewHeight * settings.inview.bottom;
				// Because IE11
				const isInViewCompatible =
					elementOffsetTopInViewHeight - offsetTop >= 0 &&
					elementOffsetTopInViewHeight + offsetBottom <= data.inViewHeight;
				if (isInViewCompatible) {
					$el.classList.add('is-active');
				} else {
					$el.classList.remove('is-active');
				}
			});
		});
	}

	if ($inviewimages.length > 0) {
		$inviewimages.forEach($el => {
			// If image with is-hidden-mobile doesn't exist, then get the first image (to determine image to use as background)
			const $img = $el.querySelector('img.is-hidden-mobile') || $el.querySelector('img');
			$img.addEventListener('load', () => {
				// Convert regular image to element with background image. Fixed height and width since width will be adjusted on scroll
				let width = $el.clientWidth;
				$el.style.height = `${$el.clientHeight}px`;
				$el.style.width = '100vw';
				// Initialize with JS related CSS
				$el.classList.add('is-initialized');
				$el.style.backgroundImage = `url(${$img.currentSrc})`;
				$el.style.backgroundPosition = 'top center';
				$el.style.backgroundRepeat = 'no-repeat';
				$el.style.maxWidth = '100vw';
				$el.style.backgroundSize = `${width}px`;
				// Remove actual image element
				$img.style.visibility = 'hidden';

				// Method to call on scroll
				inviewimagescbs.push((reInit) => {
					if (window.innerWidth < 769) return;
					// user resized the screen, we need to get the correct dimensions of the image again
					if (reInit) {
						$el.style.width = null;
						$el.style.height = 'auto';
						// get new values
						width = $el.clientWidth;
						$el.style.height = `${$el.clientHeight}px`;
						$el.style.width = '100vw';
					}
					const rect = $el.getBoundingClientRect();
					// rect.top is the amount of pixels that the top of the element is away from the top of the viewport
					// rect.bottom is the amount of pixels that the bottom of the element is away from the top of the viewport
					// No matter the scrolling direction, we want to start doing magic, when the element is at least x pixels visible at the top and/or x pixels visible at the bottom
					const offsetTop = window.innerHeight * settings.inviewimage.top;
					const offsetBottom = window.innerHeight * settings.inviewimage.bottom;
					const minPositionTop = 0 - $el.clientHeight + offsetTop;
					const maxPositionTop = window.innerHeight - offsetBottom;
					const isVisibleTop = rect.top >= minPositionTop;
					const isVisibleBottom = rect.top <= maxPositionTop;
					if (isVisibleTop && isVisibleBottom) {
						// Determine the percentage the user is at. Since minPositionTop is a negative, number, add its absolute to the maxPositionTop and to the rect.top
						const addablewidth = window.innerWidth - width; // Max amount of width to add on top of the startwidth (min/auto width of the image)
						const positiverecttop = rect.top + Math.abs(minPositionTop); // Convert the possible min values to positive values, so they can be used to calculate percentage
						const positivemaxtop = maxPositionTop + Math.abs(minPositionTop); // Convert the possible min values to positive values, so they can be used to calculate percentage
						const modifier = 1 - positiverecttop / positivemaxtop; // Determine the fraction of the user's position (ie 0.34)
						$el.style.backgroundSize = `${width + addablewidth * modifier * settings.inviewimage.speed}px`;
					} else if (!isVisibleTop && isVisibleBottom) {
						$el.style.backgroundSize = `${window.innerWidth}px`;
					} else {
						$el.style.backgroundSize = `${width}px`;
					}
				});
			});
			// force onload to trigger
			$img.src = $img.currentSrc;
		});

		// Start listening
		window.addEventListener('scroll', () => {
			for (let i = 0; i < inviewimagescbs.length; i += 1) {
				inviewimagescbs[i]();
			}
		});


		const onResize = () => {
			inviewimagescbs.forEach((el, i) => {
				inviewimagescbs[i](true);
			})
		}

		const debounced = debounce(onResize, 300);
		window.addEventListener('resize', debounced);
	}
};

module.exports = {
	init
};
